import React from 'react';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { ImportOffPaletteColor, ImportPaletteColor } from '../types';
import { PRES, TYPE } from '../chrome';

export function isImportColorMapComplete(
  colors: ImportOffPaletteColor[],
  map: Record<string, string>
): boolean {
  return colors.every((color) => Boolean(String(map[color.hex] || '').trim()));
}

interface ImportColorMatchProps {
  colors: ImportOffPaletteColor[];
  palette: ImportPaletteColor[];
  value: Record<string, string>;
  disabled?: boolean;
  onChange: (next: Record<string, string>) => void;
}

const ImportColorMatch: React.FC<ImportColorMatchProps> = ({
  colors,
  palette,
  value,
  disabled,
  onChange,
}) => (
  <Box sx={{ mt: 2 }}>
    <Typography variant="subtitle1" sx={{ color: PRES.textPrimary, fontWeight: 700 }}>
      {COPY.importColorMismatch}
    </Typography>
    <Typography variant="body2" sx={{ mt: 0.75, mb: 1.5, color: PRES.muted }}>
      {COPY.importColorMismatchHelp}
    </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      {colors.map((color) => (
        <Box
          key={color.hex}
          sx={{
            display: 'grid',
            gridTemplateColumns: '28px 96px 1fr',
            alignItems: 'center',
            gap: 1.25,
          }}
        >
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: color.hex,
              border: `1px solid ${color.hex === '#FFFFFF' ? PRES.borderStrong : 'rgba(0,0,0,0.12)'}`,
            }}
          />
          <Typography sx={{ fontFamily: TYPE.tabular, fontSize: 12, color: PRES.textPrimary }}>
            {color.hex}
          </Typography>
          <Select
            size="small"
            displayEmpty
            disabled={disabled}
            value={value[color.hex] || ''}
            onChange={(event) => onChange({ ...value, [color.hex]: String(event.target.value) })}
            inputProps={{ 'aria-label': `${COPY.importColorPick} ${color.hex}` }}
            sx={{ fontFamily: TYPE.ui, fontSize: 13 }}
          >
            <MenuItem value="" disabled>
              {COPY.importColorPick}
            </MenuItem>
            {palette.map((item) => (
              <MenuItem key={item.id} value={item.hex}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      borderRadius: '50%',
                      bgcolor: item.hex,
                      border: `1px solid ${item.hex === '#FFFFFF' ? PRES.borderStrong : 'rgba(0,0,0,0.16)'}`,
                    }}
                  />
                  {item.name}
                </Box>
              </MenuItem>
            ))}
          </Select>
        </Box>
      ))}
    </Box>
  </Box>
);

export default ImportColorMatch;
